import React from 'react';
import { Pagination as BootstrapPagination, PaginationItem, PaginationLink } from 'reactstrap';

export default function CursorPagination(props) {
  const { hasPrev, hasNext, page, onFirst, onPrev, onNext } = props;
  return (
    <div className="d-flex align-items-center gap-2">
      <div className="small text-muted">
        ページ {page}
      </div>
      <BootstrapPagination listClassName="m-0">
        <PaginationItem disabled={!hasPrev}>
          <PaginationLink onClick={onFirst}>
            <span className="fas fa-angle-double-left" />
          </PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={!hasPrev}>
          <PaginationLink onClick={onPrev}>
            <span className="fas fa-angle-left" />
          </PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={!hasNext}>
          <PaginationLink onClick={onNext}>
            <span className="fas fa-angle-right" />
          </PaginationLink>
        </PaginationItem>
      </BootstrapPagination>
    </div>
  );
};
